import { render } from "./Duration.vue?vue&type=template&id=29f36c29&scoped=true&lang=pug"
import script from "./Duration.vue?vue&type=script&lang=js"
export * from "./Duration.vue?vue&type=script&lang=js"

import "./Duration.vue?vue&type=style&index=0&id=29f36c29&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f36c29"]])

export default __exports__